// extracted by mini-css-extract-plugin
export default {"awards":"Awards_awards__P+X8D","cardHeader":"Awards_cardHeader__KDnZL","grid3":"Awards_grid3__tkxfh"};